import SampleClassification from './sampleclassification'

export default SampleClassification
